/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Doc_Upload_Failed_FileInputs */

const en_doc_upload_failed_file = /** @type {(inputs: Doc_Upload_Failed_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to upload ${i?.name}`)
};

const pt_br2_doc_upload_failed_file = /** @type {(inputs: Doc_Upload_Failed_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao enviar ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Failed to upload {name}" |
*
* @param {Doc_Upload_Failed_FileInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_failed_file = /** @type {((inputs: Doc_Upload_Failed_FileInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_Failed_FileInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_failed_file(inputs)
	return pt_br2_doc_upload_failed_file(inputs)
});